import { useMemo } from 'react';

import { useHouseholdWorkflowTrackersContext } from '@/modules/workflowTrackers/contexts';
import { WorkflowTrackerKind } from '@/types/schema';

/**
 * Hook to determine if a specific workflow kind is currently in progress for a given household.
 *
 * @param kind
 */
export function useIsHouseholdWorkflowTrackerInProgress(
  kind: WorkflowTrackerKind
): boolean {
  const { awaitingTrackerCompletionByKind } =
    useHouseholdWorkflowTrackersContext();

  return useMemo(() => {
    // If we are awaiting completion of any trackers of this kind, return true
    return Boolean(awaitingTrackerCompletionByKind?.[kind]?.length);
  }, [awaitingTrackerCompletionByKind, kind]);
}
